export default "__VITE_ASSET__1OCNpjet__"